import { c as _c } from "react/compiler-runtime";
import type { Note } from '@/lib/music/theory/spn';
import { transpose } from '@/lib/music/theory/spn';
import { useMemo } from 'react';
export const useValidStartNotes = () => {
  const $ = _c(2);
  let notes;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    notes = [];
    const startNote = {
      letter: "A",
      octave: -1
    };
    const endNote = {
      letter: "B",
      octave: 0
    };
    let currentNote = startNote;
    while (true) {
      notes.push(currentNote);
      if (currentNote.letter === endNote.letter && currentNote.octave === endNote.octave) {
        break;
      }
      currentNote = transpose(currentNote, 1);
    }
    $[0] = notes;
  } else {
    notes = $[0];
  }
  const validStartNotes = notes;
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      validStartNotes
    };
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};